import React, { useEffect, useState } from "react";
import styles from "./scss/notecreate.module.scss";
//import ReactQuill from 'react-quill'; // Typescript
import 'react-quill/dist/quill.snow.css';
import { URButton } from "../../../shared/widgets/button";
import { contactService } from "../../../base/contactService";
import TextArea from "antd/lib/input/TextArea";
import { Input } from "antd";


/* type CreateNoteState={
  title:any;
  description:any;
}

type CreateNoteProps={
  handleToggle:Function
}
class CreateNote extends React.Component<CreateNoteProps, CreateNoteState> {
  constructor(props: any) {
    super(props);
    this.state = { title: '', description: '' };
  }

  onChangeInpout=(e:any)=>{
    if(e.target.name === "title"){
      this.setState({title:e.target.value});
    }
    else{
      this.setState({description:e.target.value});
    }
  };

  

  handleCancel=()=>{
    this.props.handleToggle();
  }

  handleSave=()=>{
    console.log("this.state", this.state);
    this.props.handleToggle();
  }

  render() {
    return (
      <>
        <div className={styles.rightsidebar}>
          <div className={styles.toplayers}>
            <h3>New Note<br/><span>UI Designs</span></h3>
            <span className="icon_close"></span>
          </div>
          <h3>Title</h3>
          <input onChange={this.onChangeInpout}name="title"/>
          <h3>Description</h3>
          <textarea onChange={this.onChangeInpout} name="description" />
          <div className={styles.bottomlayers}>
            <URButton name="Cancel" className={styles.cancelbtn} onClick={this.handleCancel}/>
            <URButton name="Send" className={styles.savebtn} onClick={this.handleSave}/>
          </div>
        </div>
      </>
    );
  }
} */
type CreateNoteState={
  title:any;
  description:any;
  errors:boolean;
  replace_id:any;
  sender:any;
  receiver:any;
  owner_id:any;
}
export default function CreateNote(props:any){
  let isContact= window.location.pathname=== "/contacts"?"contacts":"chats";
  const [state, setstate] = useState<CreateNoteState>({sender:"",receiver:"",title:"",description:"",
    errors:false,replace_id:"",owner_id:""});
  //const chatDetails: contactwindowDetails = useSelector((state: initialStateModel) => state.contactWindowReducer);
  //const loginDetails: LoginState = useSelector((state: initialStateModel) => state.loginReducer);
  //const chatReducer: chats = useSelector((state: initialStateModel) => state.chatReducer);
  //let {userdetails}= loginDetails;
  //let {xmppDetails}= chatReducer;
  //const MySpaceDetails: chatwindowDetails = useSelector((state: initialStateModel) => state.chatWindowReducer);
  useEffect(() => {
    if(props.isEdit){
      setstate({...state,sender:props.noteData.sender,receiver:props.noteData.receiver,title: props.noteData.summary, description:props.noteData.description,
        replace_id: props.noteData.replaceId ? props.noteData.replaceId :props.noteData.msgId?props.noteData.msgId:props.noteData.uid,owner_id:props.noteData.ownerId});
    }
  }, []);
  const onChangeInpout=(e:any)=>{
    setstate({...state,[e.target.name]: e.target.value, errors:false});
    
  };


  const onSend=()=>{
    if(state.title.trim() === ""){
      setstate({...state,errors:true});
      return;
    }  else {
      if(props.isEdit){
        contactService.editContactNote(state ,props.noteData.uid,isContact);
      } else {
        contactService.createContactNote(state,isContact);
      }
      setstate({ ...state, title: "", description: "", errors:false });
      props.handleToggle();
    }
   
  };

  const onCancel=()=>{
    setstate({ ...state, title: "", description: "", errors:false });
    props.handleToggle();
  };
  
 
  return (
    <>
      <div className={styles.rightsidebar}>
        {/* <div className={styles.toplayers}>
        { !props.isEdit&& <h3>New Note<br/></h3>}
          <span onClick={onCancel} className="icon_close"></span>
        </div> */}
        <div className={styles.createNotesSec}>
          {/* <h3>Title</h3> */}
          {/* <input onChange={onChangeInpout}name="title"/> */}
          <div className={styles.inputfield}>
            <Input placeholder="Title" name="title" value={state.title}
              className={`${styles.notesTitle} ${styles.inputarea}`} onChange={onChangeInpout}></Input>
          </div>
          {state.errors && <p className={styles.errorMsgs}>This note needs a title </p>}
          {/* <Input onChange={onChangeInpout} value={state.title} name="title" className="notesArea"/> */}
          {/* <h3>Description</h3> */}
          {/* <textarea onChange={onChangeInpout} name="description" /> */}
          <div className={styles.inputfield}>
            <TextArea
              name="description"
              onChange={onChangeInpout}
              value={state.description}
              placeholder="Start writing or drag files"
              autoSize={{ minRows: 3 }}
              className={styles.notesDesc}
            />
          </div>
          {/* <TextArea rows={4} onChange={onChangeInpout} value={state.description}
            name="description" className="notesArea"/> */}
          {/* {state.errors && <h3 className={styles.errors}>All fields are mandatory</h3>} */}
          <div className={styles.bottomlayers}>
            <URButton onClick={onCancel} name="Cancel" className="urButton buttonWhite "/>
            <URButton onClick={onSend} disabled={state.description.length===0&& state.title.length===0?true:false} name={props.isEdit?"Update":"Create"} className="urButton buttonBlue marlftmin"/>
          </div>
        </div>
      </div>
    </>
  );
};
